export type AtVirtualClinicAdmissionType2 =
  'P' | 'A' | 'K';

export const AT_VIRTUAL_CLINIC_ADMISSION_TYPE_2_DISPLAY_NAMES: { [admissionType2 in AtVirtualClinicAdmissionType2]: string } = {
  P: 'geplante stationäre Aufnahme/geplanter ambulanter Besuch (mit vorhergehender Terminvereinbarung, Richtwert: mindestens 24 Stunden)',
  A: 'akute stationäre Aufnahme/akuter ambulanter Besuch (ohne vorhergehende Terminvereinbarung)',
  K: 'stationäre Aufnahme/ambulanter Besuch aus Kapazitätsgründen zugewiesen'
};
